// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

// public route
const PUBLIC_URL = process.env.REACT_APP_HOME_PAGE

export function register(config) {
	if ('serviceWorker' in navigator) {
		const currentPath = window.location.pathname
		const currentHref = window.location.href
		const isProhibitedRoute =
			currentPath.includes('/par-q-public') ||
			currentPath.includes('/gestor') ||
			currentHref.includes('/par-q-public') ||
			currentHref.includes('/gestor')

		if (isProhibitedRoute) {
			// Desregistrar cualquier SW existente pero NO registrar uno nuevo
			unregister()
			return
		}

		// Verificar si acabamos de recargar por desregistro del SW
		if (sessionStorage.getItem('sw-unregistered-reload') === 'true') {
			sessionStorage.removeItem('sw-unregistered-reload')
			// No registrar SW nuevamente si acabamos de desregistrarlo
			return
		}

		const baseUrl = PUBLIC_URL || window.location.origin

		// The URL constructor is available in all browsers that support SW.
		const publicUrl = new URL(baseUrl, window.location.href)
		if (publicUrl.origin !== window.location.origin) {
			// Our service worker won't work if PUBLIC_URL is on a different origin
			// from what our page is served on. This might happen if a CDN is used to
			// serve assets; see https://github.com/facebook/create-react-app/issues/2374
			return
		}

		const swUrl = `${baseUrl}/service-worker.js`

		if (
			navigator.serviceWorker &&
			navigator.serviceWorker.controller &&
			navigator.serviceWorker.controller.state === 'activated'
		) {
			if (navigator.serviceWorker.controller.scriptURL === swUrl) return
		}

		window.addEventListener('load', () => {
			// Is not localhost. Just register service worker
			registerValidSW(swUrl, config)
		})
	}
}

function registerValidSW(swUrl, config) {
	navigator.serviceWorker
		.register(swUrl)
		.then(registration => {
			// Configurar comunicación con el service worker
			setupServiceWorkerCommunication()

			registration.onupdatefound = () => {
				const installingWorker = registration.installing
				if (installingWorker == null) {
					return
				}
				installingWorker.onstatechange = () => {
					if (installingWorker.state === 'installed') {
						if (navigator.serviceWorker.controller) {
							// At this point, the updated precached content has been fetched,
							// but the previous service worker will still serve the older
							// content until all client tabs are closed.

							// Execute callback
							if (config && config.onUpdate) {
								config.onUpdate(registration)
							}
						} else {
							// At this point, everything has been precached.
							// It's the perfect time to display a
							// "Content is cached for offline use." message.

							// Execute callback
							if (config && config.onSuccess) {
								config.onSuccess(registration)
							}
						}
					}
				}
			}
		})
		.catch(() => {
			unregister()
		})
}

// Variable para prevenir múltiples recargas
let isReloadingDueToSW = false

function setupServiceWorkerCommunication() {
	// Escuchar mensajes del service worker
	navigator.serviceWorker.addEventListener('message', event => {
		if (event.data && event.data.type === 'REQUEST_URL') {
			// El service worker solicita la URL actual
			if (navigator.serviceWorker.controller) {
				navigator.serviceWorker.controller.postMessage({
					type: 'CHECK_URL',
					url: window.location.href
				})
			}
		} else if (event.data && event.data.type === 'SW_UNREGISTERED') {
			// El service worker se ha desregistrado, recargar la página SOLO UNA VEZ
			handleServiceWorkerUnregistered()
		}
	})

	// Verificar URL actual cuando se registra por primera vez
	if (navigator.serviceWorker.controller) {
		navigator.serviceWorker.controller.postMessage({
			type: 'CHECK_URL',
			url: window.location.href
		})
	}
}

function handleServiceWorkerUnregistered() {
	// Prevenir múltiples recargas
	if (isReloadingDueToSW) {
		return
	}

	// Verificar que realmente estamos en una ruta donde no debería haber SW
	const currentPath = window.location.pathname
	const shouldNotHaveSW = currentPath.includes('/par-q-public') || currentPath.includes('/gestor')

	if (shouldNotHaveSW) {
		isReloadingDueToSW = true

		// Marcar en sessionStorage para evitar loop en la próxima carga
		sessionStorage.setItem('sw-unregistered-reload', 'true')

		// Recargar después de un pequeño delay para asegurar que el SW se desregistró
		setTimeout(() => {
			window.location.reload()
		}, 100)
	}
}

export function unregister() {
	if ('serviceWorker' in navigator) {
		// Método 1: Desregistrar usando registration.ready
		navigator.serviceWorker.ready.then(registration => {
			registration.unregister()
		})

		// Método 2: Desregistrar todas las registraciones existentes
		navigator.serviceWorker.getRegistrations().then(registrations => {
			registrations.forEach(registration => {
				registration.unregister()
			})
		})

		// Método 3: Limpiar caches si existen
		if ('caches' in window) {
			caches.keys().then(cacheNames => {
				cacheNames.forEach(cacheName => {
					caches.delete(cacheName)
				})
			})
		}
	}
}
